import { EvirDivision } from "src/app/models/shared.model";
import { GlobalApiCallsService } from "src/app/services/global-api-calls.service";

export type searchFn = (
	pattern: string,
	companyId: string,
	divisions: EvirDivision[],
	userHasAllDivisions: boolean,
	globalApiCallsService: GlobalApiCallsService,
) => Promise<any>;

export const searchFunctions: Record<"assets" | "divisions" | "inspectors", searchFn> = {
	assets: function (
		name: string,
		companyId: string,
		divisions: EvirDivision[],
		userHasAllDivisions: boolean,
		globalApiCallsService: GlobalApiCallsService,
	): Promise<any[]> {
		return (async () => {
			const assets = await globalApiCallsService.searchAssets(name, companyId);

			return assets.filter(
				asset =>
					userHasAllDivisions ||
					asset.divisions.find(division => divisions.find(div => div.divisionId === division)),
			);
		})();
	},
	divisions: function (
		name: string,
		companyId: string,
		divisions: EvirDivision[],
		userHasAllDivisions: boolean,
		globalApiCallsService: GlobalApiCallsService,
	): Promise<any[]> {
		return (async () => {
			const companyDivisions = await globalApiCallsService.searchCompanyDivision(name, companyId);

			return companyDivisions.filter(
				companyDivision =>
					userHasAllDivisions || divisions.find(division => division.divisionId === companyDivision.id),
			);
		})();
	},
	inspectors: function (
		pattern: string, // pattern
		companyId: string, // companyId
		_: EvirDivision[], // divisions
		__: boolean, // userHasAllDivisions
		globalApiCallsService: GlobalApiCallsService,
	): Promise<any[]> {
		return (async () => {
			return globalApiCallsService.searchInspectors(pattern, companyId);
		})();
	},
};
